<template>
  <div>
    <v-divider class="mx-4" />
    <v-list-item
      :active="active"
      color="primary"
      append-icon="mdi-chevron-right"
      class="my-2"
      @click="emit('click')"
    >
      <v-list-item-title class="flex items-center gap-1">
        {{ t("comments.title") }}
        <v-badge v-if="unreadCount" inline color="warning" :content="unreadCount" />
      </v-list-item-title>
      <template v-if="lastComment">
        <v-list-item-subtitle class="font-medium">{{
          isOwnComment(lastComment, user.uid)
            ? t("comments.you")
            : commentAuthorLabel(lastComment.author)
        }}</v-list-item-subtitle>
        <v-list-item-subtitle class="line-clamp-1">{{
          lastComment.text.replace(/\s+/g, " ").trim()
        }}</v-list-item-subtitle>
      </template>
      <v-list-item-subtitle v-else>{{ emptyLabel ?? t("comments.empty") }}</v-list-item-subtitle>
    </v-list-item>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from "@/composables/useI18n";
import { useUserStore } from "@/store";
import { isOwnComment } from "@/utils/comments";
import { commentAuthorLabel, type Comment } from "@aircap/common/comment";
import { computed } from "vue";
import type { VueFirestoreQueryData } from "vuefire";

const props = defineProps<{
  comments: VueFirestoreQueryData<Comment>;
  unreadCount: number;
  active: boolean;
  emptyLabel?: string;
}>();

const emit = defineEmits<{ click: [] }>();

const { t } = useI18n();
const user = useUserStore();

const lastComment = computed(() => props.comments.at(-1));
</script>
